import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import '../../HTMLIntro.css'; // Reusing the same CSS file

const JavaScriptOutline = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const courseSections = [
    { id: 'introduction', title: 'Introduction to JavaScript', path: '/javascript-introduction' },
    { id: 'standards', title: 'Standardization of JavaScript', path: '/javascript-standards' },
    { id: 'setup', title: 'Setup JavaScript', path: '/javascript-setup' },
    { id: 'placement', title: 'Placement of JavaScript', path: '/javascript-placement' },
    { id: 'terminal', title: 'Run JavaScript from terminal', path: '/javascript-terminal' },
    { id: 'variables', title: 'JavaScript Variables', path: '/javascript-variable' },
    { id: 'declaration', title: 'Variable Declaration', path: '/javascript-declaration' },
    { id: 'hoisting', title: 'Hoisting', path: '/javascript-variable-hoisting' },
    { id: 'scope', title: 'Variable Scope', path: '/javascript-variable-scope' },
    { id: 'naming', title: 'Variable Naming Conventions', path: '/javascript-variable-namingconvention' },
    { id: 'reserved-words', title: 'Reserved Words', path: '/javascript-reserved-words' },
    { id: 'operators', title: 'Operators', path: '/javascript-operators' },
    { id: 'operator-types', title: 'Types of Operators', path: '/javascript-types-of-operator' },
    { id: 'data-types', title: 'Data Types', path: '/javascript-data-types' },
    { id: 'functions', title: 'Functions', path: '/javascript-functions' },
    { id: 'control-structures', title: 'Control Structures', path: '/javascript-controlstructures' },
    { id: 'loops', title: 'Loops', path: '/javascript-loops' },
    { id: 'arrays', title: 'Arrays', path: '/javascript-arrays' },
    { id: 'rest-parameters', title: 'Rest Parameters', path: '/javascript-rest-parameters' },
    { id: 'objects', title: 'Objects', path: '/javascript-object' },
    { id: 'recursion', title: 'Recursion', path: '/javascript-recursive-functions' },
    { id: 'oop', title: 'Object Oriented Programming', path: '/javascript-oriented-programming' },
    { id: 'string-methods', title: 'String Methods', path: '/javascript-string-methods' },
    { id: 'async', title: 'Callbacks, Promises, Async/await', path: '/javascript-callbacks' },
    { id: 'api', title: 'API', path: '/javascript-api' },
    { id: 'ajax', title: 'AJAX Methodology', path: '/javascript-ajax' },
    { id: 'reqres', title: 'Reqres', path: '/javascript-reqres' }
  ];

  return (
    <HTMLCourseNavProvider>
      <div className="modern-course-container">
        <SideBar />
        
        <div className="course-content">
          <div className="course-header">
            <h1 className="course-title">JavaScript Course</h1>
            <p className="course-subtitle">Master the language of the web - from fundamentals to advanced concepts</p>
            <div className="progress-container">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: '0%' }}></div>
              </div>
              <span className="progress-text">0% Complete</span>
            </div>
          </div>

          <div className="course-outline-card">
            <div className="card-header">
              <h2 className="card-title">
                <i className="fab fa-js-square me-2"></i>
                Course Outline
              </h2>
              <span className="lesson-count">{courseSections.length} lessons</span>
            </div>

            <div className="lessons-container">
              {courseSections.map((section, index) => (
                <div key={section.id} className="lesson-section">
                  <div 
                    className={`lesson-item ${expandedSections[section.id] ? 'expanded' : ''}`}
                    onClick={() => section.sublessons && toggleSection(section.id)}
                  >
                    <div className="lesson-number">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    
                    <div className="lesson-content">
                      <Link 
                        to={section.path} 
                        className="lesson-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {section.title}
                      </Link>
                      
                      {section.sublessons && (
                        <button className="expand-btn">
                          <i className={`fas fa-chevron-${expandedSections[section.id] ? 'up' : 'down'}`}></i>
                        </button>
                      )}
                    </div>

                    <div className="lesson-status">
                      <span className="status-badge">Start</span>
                    </div>
                  </div>

                  {section.sublessons && expandedSections[section.id] && (
                    <div className="sublessons-container">
                      {section.sublessons.map((sublesson, subIndex) => (
                        <Link 
                          key={subIndex} 
                          to={sublesson.path} 
                          className="sublesson-item"
                        >
                          <div className="sublesson-number">
                            {index + 1}.{subIndex + 1}
                          </div>
                          <span className="sublesson-title">{sublesson.title}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="card-footer">
              <button className="start-course-btn">
                <i className="fas fa-code me-2"></i>
                Start Coding with JavaScript
              </button>
            </div>
          </div>
        </div>
      </div>
    </HTMLCourseNavProvider>
  );
};

export default JavaScriptOutline;